import * as React from 'react';

import { InstantWin } from 'models/instantWin';
import { InstantWinEvent } from 'models/instantWinEvent';

import { Modal } from './Modal/Modal';
import { ETicket } from './Prize/ETicket';
import { PromoCode } from './Prize/PromoCode';
import { Gift } from './Prize/Gift';
import { Download } from './Prize/Download';

import styles from './InstantWinTierModal.module.css';

interface OwnProps {
  open: boolean;
  onClose: () => void;
  instantWin: InstantWin;
  instantWinEvent: InstantWinEvent;
  tierKey: string;
}

type Props = OwnProps;

export const InstantWinTierModal = ({
  open,
  onClose,
  instantWin,
  instantWinEvent,
  tierKey,
}: Props) => {
  const tier = instantWin?.tiers?.find((tier) => tier?.key === tierKey);

  return (
    <Modal onClose={onClose} open={open}>
      <div className={styles.modalContent}>
        {tier?.type === 'INSTANT_WIN_TIER_TYPE_E_TICKET' &&
          instantWinEvent?.created_reservation_id && (
            <ETicket
              onClose={onClose}
              instantWin={instantWin}
              instantWinEvent={instantWinEvent}
              tierKey={tierKey}
            />
          )}
        {tier?.type === 'INSTANT_WIN_TIER_TYPE_GIFT' && (
          <Gift
            onClose={onClose}
            instantWin={instantWin}
            instantWinEvent={instantWinEvent}
            tierKey={tierKey}
          />
        )}
        {tier?.type === 'INSTANT_WIN_TIER_TYPE_DOWNLOAD' && (
          <Download
            onClose={onClose}
            instantWin={instantWin}
            instantWinEvent={instantWinEvent}
            tierKey={tierKey}
          />
        )}
        {tier?.type === 'INSTANT_WIN_TIER_TYPE_PROMO_CODE' && instantWinEvent?.promo_code && (
          <PromoCode
            onClose={onClose}
            instantWin={instantWin}
            instantWinEvent={instantWinEvent}
            tierKey={tierKey}
          />
        )}
      </div>
    </Modal>
  );
};
